
export enum SettingNames {
    AlbertaAccountEnableVerified = "AlbertaAccountEnableVerified",
    AlbertaAccountEnablePending = "AlbertaAccountEnablePending",
    AlbertaAccountEnableBasic = "AlbertaAccountEnableBasic",
    ProxyApplications = "ProxyApplications",
    PaymentTypeEnableETransfer = "PaymentTypeEnableETransfer",
    PaymentTypeEnableETransferGLAutoPosting = "PaymentTypeEnableETransferGLAutoPosting",
    PaymentTypeETransferMessage = "PaymentTypeETransferMessage",
    PaymentTypeEnableDebitCard = "PaymentTypeEnableDebitCard",
    PaymentTypeEnableDebitCardGLAutoPosting = "PaymentTypeEnableDebitCardGLAutoPosting",
    PaymentTypeEnableEFT = "PaymentTypeEnableEFT",
    PaymentTypeEnableEFTGLAutoPosting = "PaymentTypeEnableEFTGLAutoPosting",
    PaymentBatchInterval = "PaymentBatchInterval",
    WorkspaceColumnDisplay = "WorkspaceColumnDisplay",
    SearchColumnDisplay = "SearchColumnDisplay",
    IsSeasonal = "IsSeasonal",
    PaymentAmount = "PaymentAmount",
    AgeCalculationDate = "AgeCalculationDate",
    EoDashboardColumnDisplay = "EoDashboardColumnDisplay",
    ProgramDisplayName = "ProgramDisplayName",

    // adjudication settings
    AutomatedApplicationApproval = 'AutomatedApplicationApproval',
    PaymentBatchCreationTimeframe = 'PaymentBatchCreationTimeframe',
    PaymentBatchSubmissionTimeframe = 'PaymentBatchSubmissionTimeframe',
    MaximumAdultFamilyMemberAlert = 'MaximumAdultFamilyMemberAlert',
    MaximumFamilyMemberAlert = 'MaximumFamilyMemberAlert',
    AutoClearWorkspace = 'AutoClearWorkspace',
    IsManualBulkApplicationApprovalEnabled = 'IsManualBulkApplicationApprovalEnabled',
    IsAutomatedApplicationFollowupEnabled = 'IsAutomatedApplicationFollowupEnabled',
    IsAutomatedPaymentAuthorizationEnabled = 'IsAutomatedPaymentAuthorizationEnabled',
    IsAutomatedDuplicateAlertEnabled = 'IsAutomatedDuplicateAlertEnabled',
    IsEventEnabled = 'IsEventEnabled',
    IsAlertsEnabled = 'IsAlertsEnabled',
    IsCityEnabled = 'IsCityEnabled',
    IsPostalCodeEnabled = 'IsPostalCodeEnabled',
    IsApplicationTypeEnabled = 'IsApplicationTypeEnabled',
    ManualFollowupReasons = "ManualFollowupReasons",
    VerificationStatutoryDeclarationTypes = "VerificationStatutoryDeclarationTypes",
    VerificationStatutoryDeclarationReasons = "VerificationStatutoryDeclarationReasons",
    PaymentCancellationReasons = "PaymentCancellationReasons",
    AdditionalPayments = "AdditionalPayments",
    IsAdditionalPaymentsAllowedEditing = "IsAdditionalPaymentsAllowedEditing",
    InternalSupportEmail = "InternalSupportEmail",

    // internal email notifications
    InternalNotificationsSenderEmail = 'InternalNotificationsSenderEmail',
    InternalNotificationsEORecipientsEmail = 'InternalNotificationsEORecipientsEmail',
    InternalNotificationsAdditionalRecipientsEmail = 'InternalNotificationsAdditionalRecipientsEmail',
    InternalNotificationsBatchCreated = 'InternalNotificationsBatchCreated',
    InternalNotificationsBatchReminder = 'InternalNotificationsBatchReminder',
    InternalNotificationsBatchAuthorized = 'InternalNotificationsBatchAuthorized',
    InternalNotificationsPaymentHeld = 'InternalNotificationsPaymentHeld',
    InternalNotificationsBatchHeld = 'InternalNotificationsBatchHeld',
    InternalNotificationsApplicationRemoved='InternalNotificationsApplicationRemoved',
    InternalNotificationsPaymentCancelSuccess='InternalNotificationsPaymentCancelSuccess',
    InternalNotificationsPaymentCancelFailed='InternalNotificationsPaymentCancelFailed',
    InternalNotificationsSystemExceptionEmails = 'InternalNotificationsSystemExceptionEmails',
    InternalNotificationsTemplateSettings='InternalNotificationsTemplateSettings',
    InternalNotificationsEmailTemplate = 'InternalNotificationsEmailTemplate',
    
    SummaryDetailsDisplay = 'SummaryDetailsDisplay',
    EoDashboardDetailColumnDisplay = 'EoDashboardDetailColumnDisplay',

    //technical settings
    PublicPortalUrl = "PublicPortalUrl",
    BatchReminderSchedule = "BatchReminderSchedule",
    DeadLetterProcessingSchedule = "DeadLetterProcessingSchedule",
    UpdatePaymentSchedule = "UpdatePaymentSchedule",
    ReadyToSendSchedule = "ReadyToSendSchedule",
    ScheduledMaintenanceSupportInformation = "ScheduledMaintenanceSupportInformation",
    GLConfigByEvent = "GLConfigByEvent",

    // public email notifications
    PublicNotificationsSenderEmail = "PublicNotificationsSenderEmail",
    PublicNotificationsFinishLater = "PublicNotificationsFinishLater",
    PublicNotificationsApplicationSubmitted = "PublicNotificationsApplicationSubmitted",
    PublicNotificationsAutomatedFollowUp = "PublicNotificationsAutomatedFollowUp",
    PublicNotificationsManualFollowUp = "PublicNotificationsManualFollowUp",
    PublicNotificationsApplicationUpdated = "PublicNotificationsApplicationUpdated",
    PublicNotificationsPaymentSent = "PublicNotificationsPaymentSent",
    PublicNotificationsPaymentSentProxyApplication = "PublicNotificationsPaymentSentProxyApplication",
    PublicNotificationsApplicationRejected = "PublicNotificationsApplicationRejected",
    PublicNotificationsApplicationWithdrawn = "PublicNotificationsApplicationWithdrawn",
    PublicNotificationsAutomatedFollowUpOptOut = "PublicNotificationsAutomatedFollowUpOptOut",
    PublicNotificationsTemplateSettings = "PublicNotificationsTemplateSettings",
    PublicNotificationsEmailTemplate = 'PublicNotificationsEmailTemplate',

    // Status Messaging
    StatusMessagingSubmitted = "StatusMessagingSubmitted",
    StatusMessagingProcessing = "StatusMessagingProcessing",
    StatusMessagingPaymentSent = "StatusMessagingPaymentSent",
    StatusMessagingPaymentComplete = "StatusMessagingPaymentComplete",
    StatusMessagingRejected = "StatusMessagingRejected",
    StatusMessagingWithdrawn = "StatusMessagingWithdrawn",
    StatusMessagingClosed = "StatusMessagingClosed",
    StatusMessagingVerifiedAccountFollowUp = "StatusMessagingVerifiedAccountFollowUp",
    StatusMessagingVerifiedAccountFollowUpInstruction = "StatusMessagingVerifiedAccountFollowUpInstruction",
    StatusMessagingVerificationStatusUpdated = "StatusMessagingVerificationStatusUpdated",
    StatusMessagingBasicAccountFollowUp = "StatusMessagingBasicAccountFollowUp",
    PublicNotificationsSupportInformation = "PublicNotificationsSupportInformation"
}

export enum SettingDescriptions {
    AlbertaAccountEnableVerifiedDescription = "AlbertaAccountEnableVerified",
    AlbertaAccountEnablePendingDescription = "AlbertaAccountEnablePending",
    AlbertaAccountEnableBasicDescription = "AlbertaAccountEnableBasic",
    ProxyApplicationsDescription = "ProxyApplications",
    PaymentTypeEnableETransferDescription = "PaymentTypeEnableETransfer",
    PaymentTypeEnableETransferGLAutoPostingDescription = "PaymentTypeEnableETransferGLAutoPosting",
    PaymentTypeETransferMessage = "PaymentTypeETransferMessage",
    PaymentTypeEnableDebitCardDescription = "PaymentTypeEnableDebitCard",
    PaymentTypeEnableDebitCardGLAutoPostingDescription = "PaymentTypeEnableDebitCardGLAutoPosting",
    PaymentTypeEnableEFTDescription = "PaymentTypeEnableEFT",
    PaymentTypeEnableEFTGLAutoPostingDescription = "PaymentTypeEnableEFTGLAutoPosting",
    PaymentBatchIntervalDescription = "PaymentBatchInterval",
    WorkspaceColumnDisplayDescription = "Which data columns to display on the Adjudicator workspace",
    SearchColumnDisplayDescription = "SearchColumnDisplay Which data columns to display on the Basic Search results.",
    IsSeasonal = "IsSeasonal",
    PaymentAmount = "PaymentAmount",
    AgeCalculationDate = "AgeCalculationDate",
    EoDashboardColumnDisplayDescription = "Which data columns to display on the EO dashboard",
    ProgramDisplayName = "Citizen-facing program name",

    // adjudication settings
    AutomatedApplicationApproval='AutomatedApplicationApproval',
    PaymentBatchCreationTimeframe='PaymentBatchCreationTimeframe',
    PaymentBatchSubmissionTimeframe='PaymentBatchSubmissionTimeframe',
    MaximumAdultFamilyMemberAlert='MaximumAdultFamilyMemberAlert',
    MaximumFamilyMemberAlert='MaximumFamilyMemberAlert',
    AutoClearWorkspace='AutoClearWorkspace',
    IsManualBulkApplicationApprovalEnabled='IsManualBulkApplicationApprovalEnabled',
    IsAutomatedApplicationFollowupEnabled='IsAutomatedApplicationFollowupEnabled',
    IsAutomatedPaymentAuthorizationEnabled='IsAutomatedPaymentAuthorizationEnabled',
    IsAutomatedDuplicateAlertEnabled='IsAutomatedDuplicateAlertEnabled',
    IsEventEnabled='IsEventEnabled',
    IsAlertsEnabled='IsAlertsEnabled',
    IsCityEnabled='IsCityEnabled',
    IsPostalCodeEnabled='IsPostalCodeEnabled',
    IsApplicationTypeEnabled='IsApplicationTypeEnabled',
    ManualFollowupReasons = "ManualFollowupReasons",
    VerificationStatutoryDeclarationTypes = "VerificationStatutoryDeclarationTypes",
    VerificationStatutoryDeclarationReasons = "VerificationStatutoryDeclarationReasons",
    PaymentCancellationReasons = "PaymentCancellationReasons",
    AdditionalPayments = "AdditionalPayments",
    IsAdditionalPaymentsAllowedEditing = "IsAdditionalPaymentsAllowedEditing",
    InternalSupportEmail = "InternalSupportEmail",

    // internal email notifications
    InternalNotificationsSenderEmail = 'InternalNotificationsSenderEmail',
    InternalNotificationsEORecipientsEmail = 'InternalNotificationsEORecipientsEmail',
    InternalNotificationsAdditionalRecipientsEmail = 'InternalNotificationsAdditionalRecipientsEmail',
    InternalNotificationsBatchCreated = 'InternalNotificationsBatchCreated',
    InternalNotificationsBatchReminder = 'InternalNotificationsBatchReminder',
    InternalNotificationsBatchAuthorized = 'InternalNotificationsBatchAuthorized',
    InternalNotificationsPaymentHeld = 'InternalNotificationsPaymentHeld',
    InternalNotificationsBatchHeld = 'InternalNotificationsBatchHeld',
    InternalNotificationsApplicationRemoved='InternalNotificationsApplicationRemoved',
    InternalNotificationsPaymentCancelSuccess='InternalNotificationsPaymentCancelSuccess',
    InternalNotificationsPaymentCancelFailed='InternalNotificationsPaymentCancelFailed',
    InternalNotificationsSystemExceptionEmails = 'Internal Notifications for the System Exception Emails',
    InternalNotificationsTemplateSettings='InternalNotificationsTemplateSettings',
    InternalNotificationsEmailTemplate = 'InternalNotificationsEmailTemplate',
    
    SummaryDetailsDisplayDescription = 'Summary Details Display Which data columns to display on the Summary details section.',
    EoDashboardDetailColumnDisplayDescription = 'Which data columns to display on the EO dashboard detail',

    //technical settings
    PublicPortalUrl = "PublicPortalUrl",
    PublicPaymentsServiceClientId = "PublicPaymentsServiceClientId",
    PublicPaymentsServiceClientSecret = "PublicPaymentsServiceClientSecret",
    PublicPaymentsServiceSubscriptionEndPoint = "PublicPaymentsServiceSubscriptionEndPoint",
    PublicPaymentsServiceSubscriptionName = "PublicPaymentsServiceSubscriptionName",
    ScheduledMaintenanceSupportInformation = "ScheduledMaintenanceSupportInformation",
    GLConfigByEvent = "GLConfigByEvent",

    // public email notifications
    PublicNotificationsSenderEmail = "PublicNotificationsSenderEmail",
    PublicNotificationsFinishLater = "PublicNotificationsFinishLater",
    PublicNotificationsApplicationSubmitted = "PublicNotificationsApplicationSubmitted",
    PublicNotificationsAutomatedFollowUp = "PublicNotificationsAutomatedFollowUp",
    PublicNotificationsManualFollowUp = "PublicNotificationsManualFollowUp",
    PublicNotificationsApplicationUpdated = "PublicNotificationsApplicationUpdated",
    PublicNotificationsPaymentSent = "PublicNotificationsPaymentSent",
    PublicNotificationsPaymentSentProxyApplication = "PublicNotificationsPaymentSentProxyApplication",
    PublicNotificationsApplicationRejected = "PublicNotificationsApplicationRejected",
    PublicNotificationsApplicationWithdrawn = "PublicNotificationsApplicationWithdrawn",
    PublicNotificationsAutomatedFollowUpOptOut = "PublicNotificationsAutomatedFollowUpOptOut",
    PublicNotificationsTemplateSettings = "PublicNotificationsTemplateSettings",
    PublicNotificationsEmailTemplate = 'PublicNotificationsEmailTemplate',

    // Status Messaging
    StatusMessagingSubmitted = "StatusMessagingSubmitted",
    StatusMessagingProcessing = "StatusMessagingProcessing",
    StatusMessagingPaymentSent = "StatusMessagingPaymentSent",
    StatusMessagingPaymentComplete = "StatusMessagingPaymentComplete",
    StatusMessagingRejected = "StatusMessagingRejected",
    StatusMessagingWithdrawn = "StatusMessagingWithdrawn",
    StatusMessagingClosed = "StatusMessagingClosed",
    StatusMessagingVerifiedAccountFollowUp = "StatusMessagingVerifiedAccountFollowUp",
    StatusMessagingVerifiedAccountFollowUpInstruction = "StatusMessagingVerifiedAccountFollowUpInstruction",
    StatusMessagingVerificationStatusUpdated = "StatusMessagingVerificationStatusUpdated",
    StatusMessagingBasicAccountFollowUp = "StatusMessagingBasicAccountFollowUp",
    PublicNotificationsSupportInformation = "PublicNotificationsSupportInformation"
}

